export const actionType = {
  FETCH_POST: "FETCH_POST",
  FETCH_ALL: "FETCH_ALL",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  LIKE: "LIKE",
  AUTH: "AUTH",
  LOGOUT: "LOGOUT",
  SEARCHPOST: "SEARCHPOST",
  COMMENT_POST: "COMMENT_POST",
  START_LOADING: "START_LOAING",
  END_LOADING: "END_LOADING",
};
